import { Controller } from "@hotwired/stimulus";
import { TurboStreamHeaders } from "../shared/turbo_stream_headers";
import { Turbo } from "@hotwired/turbo-rails";

// Connects to data-controller="resumin--location"
export default class extends Controller {
  static targets = ["city"];

  connect() {
    TurboStreamHeaders(this);
  }

  fillCity(e) {
    e.preventDefault();

    this._fetchData(e.currentTarget.value);
  }

  _fetchData(value) {
    const params = { prefecture_id: value, target_id: this.cityTarget.id };
    const query = new URLSearchParams(params).toString();

    fetch(`/cities?${query}`, {
      method: "GET",
      headers: {
        ...this.turboStreamHeaders(),
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.text();
      })
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((err) => {
        console.error("エラー:", err);
      });
  }
}
